module.exports = __webpack_public_path__ + "static/media/women.bf4f92c7.svg";